import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { DocumentKind } from "@bitory-gmbh/bsm";

export interface Relationship {
  id: UUID;
  companyId: UUID;
  branchId: UUID;
  customerId: UUID;
  serviceObjectId: UUID;
  commitments: Commitment[];
  serviceKinds: GSMServiceKind[];
  nextCommitmentAt: string | undefined;
  start: string;
  end: string;
  createdAt: RFC3339timestamp;
  updatedAt: RFC3339timestamp;
}

export interface Commitment {
  id: UUID;
  relationshipId: UUID;
  serviceKind: GSMServiceKind;
  status: CommitmentStatus;
  seriesId: UUID | null;
  cycle: number;
  date: string;
  processId: UUID | null;
  documentId: UUID | null;
  documentKind: DocumentKind | null;
  plannedHours: number;
  actualHours: number;
  price: number;
  comment: string;
  createdAt: RFC3339timestamp;
  updatedAt: RFC3339timestamp;
}

export enum CommitmentStatus {
  NotFulfilled = "not_fulfilled",
  PartiallyFulfilled = "partially_fulfilled",
  Fulfilled = "fulfilled",
  Skipped = "skipped",
}

export const CommitmentStatusList = Object.values(CommitmentStatus);

export function parseCommitmentStatus(
  str: string,
): CommitmentStatus | undefined {
  switch (str.toLowerCase()) {
    case "not_fulfilled":
      return CommitmentStatus.NotFulfilled;
    case "partially_fulfilled":
      return CommitmentStatus.PartiallyFulfilled;
    case "fulfilled":
      return CommitmentStatus.Fulfilled;
    case "skipped":
      return CommitmentStatus.Skipped;
    default:
      return undefined;
  }
}

export function nextCycleDate(commitment: Commitment): string {
  const cycleInDays = commitment.cycle * 7; // days
  const commitmentDate = new Date(commitment.date);
  const nextDate = new Date(
    new Date(commitmentDate).setDate(commitmentDate.getDate() + cycleInDays),
  );

  return nextDate.toISOString();
}

export interface List {
  relationships: Relationship[];
  count: number;
  offset: number;
  totalCount: number;
}

export interface CommitmentList {
  commitments: Commitment[];
  count: number;
  offset: number;
  totalCount: number;
}
